/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { useMemo } from 'react';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';

import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import styles from './AnalyticsDebug.module.scss';
import { analyticsCountReset } from '../chat/DocumentVersionFeedback/feedbackSlice';
import { showAnalyticsDebug } from '../permissions';

export function AnalyticsDebug() {
  const analytics = useAppSelector((state) => state.feedback.analyticsCounts);
  const dispatch = useAppDispatch();
  const handleAnalyticsCountReset = useMemo(() => () => dispatch(analyticsCountReset()), [dispatch]);
  if (!showAnalyticsDebug()) {
    return null;
  }

  return (
    <div className={styles.container}>
      {Object.entries(analytics).map(([event, count]) => (
        <span key={event} className={styles.count}>
          <b>{event}:</b> {count}
        </span>
      ))}
      <IconButton onClick={handleAnalyticsCountReset} className={styles.clearButton}>
        <ClearIcon />
      </IconButton>
    </div>
  );
}
